// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Block
 */
export interface Block {
  /**
   *
   * @type {string}
   * @memberof Block
   */
  blockId: string
  /**
   *
   * @type {string}
   * @memberof Block
   */
  content?: string | null
  /**
   *
   * @type {string}
   * @memberof Block
   */
  blockType?: string | null
  /**
   *
   * @type {string}
   * @memberof Block
   */
  questionType?: string | null
  /**
   *
   * @type {string}
   * @memberof Block
   */
  lexorank: string
  /**
   *
   * @type {number}
   * @memberof Block
   */
  targetWordCount?: number | null
}

/**
 * Check if a given object implements the Block interface.
 */
export function instanceOfBlock(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'blockId' in value
  isInstance = isInstance && 'lexorank' in value

  return isInstance
}

export function BlockFromJSON(json: any): Block {
  return BlockFromJSONTyped(json, false)
}

export function BlockFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): Block {
  if (json === undefined || json === null) {
    return json
  }
  return {
    blockId: json['block_id'],
    content: !exists(json, 'content') ? undefined : json['content'],
    blockType: !exists(json, 'block_type') ? undefined : json['block_type'],
    questionType: !exists(json, 'question_type')
      ? undefined
      : json['question_type'],
    lexorank: json['lexorank'],
    targetWordCount: !exists(json, 'target_word_count')
      ? undefined
      : json['target_word_count'],
  }
}

export function BlockToJSON(value?: Block | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    block_id: value.blockId,
    content: value.content,
    block_type: value.blockType,
    question_type: value.questionType,
    lexorank: value.lexorank,
    target_word_count: value.targetWordCount,
  }
}
